// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top-bar__button .icon[data-v-74a0152c]{opacity:1;margin-right:4px}.success[data-v-74a0152c]{color:white;background-color:var(--color-success);border:1px solid var(--color-success)}.success[data-v-74a0152c]:hover,.success[data-v-74a0152c]:focus,.success[data-v-74a0152c]:active{border:1px solid var(--color-success) !important}\n", ""]);
// Exports
module.exports = exports;
